import { render } from "./login-phone.vue?vue&type=template&id=27ccc4cc"
import script from "./login-phone.vue?vue&type=script&lang=js"
export * from "./login-phone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__